export default function StrategicFocus() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-slate-900 mb-16 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            Strategic Focus Areas
          </h2>

          <div className="space-y-12">
            {/* Legislative Oversight */}
            <div className="bg-white p-10 shadow-lg border-l-8 border-red-800">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-red-800 text-white mr-6 flex-shrink-0">
                  <i className="ri-government-line text-3xl"></i>
                </div>
                <div>
                  <h3 className="font-serif text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                    1. Legislative Oversight
                  </h3>
                  <p className="text-lg text-slate-700 leading-relaxed">
                    Working with the <strong>Senate Commerce Committee</strong> to update the <strong>NIST AI Risk Management Framework (RMF)</strong>. We are pushing for "Explicit Normative Constraints" to be classified as a required safety control for high-risk systems.
                  </p>
                </div>
              </div>
            </div>

            {/* Civil Rights Protection */}
            <div className="bg-white p-10 shadow-lg border-l-8 border-slate-900">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-slate-900 text-white mr-6 flex-shrink-0">
                  <i className="ri-scales-3-line text-3xl"></i>
                </div>
                <div>
                  <h3 className="font-serif text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                    2. Civil Rights Protection
                  </h3>
                  <p className="text-lg text-slate-700 leading-relaxed">
                    Partnering with the <strong>Congressional Hispanic Caucus (CHC)</strong> to identify and ban "Proxy Discrimination" in housing and lending algorithms, ensuring that AI advances equity rather than automating exclusion.
                  </p>
                </div>
              </div>
            </div>

            {/* The Mirror Audit */}
            <div className="bg-white p-10 shadow-lg border-l-8 border-red-800">
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-red-800 text-white mr-6 flex-shrink-0">
                  <i className="ri-search-eye-line text-3xl"></i>
                </div>
                <div>
                  <h3 className="font-serif text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                    3. The "Mirror" Audit
                  </h3>
                  <p className="text-lg text-slate-700 leading-relaxed">
                    Promoting the use of AI not to replace human judgment, but to <strong>audit it</strong>—using consistency checks to identify when human decision-makers are deviating from their own ethical ideals.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
